import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

export const PROCESSING = "processing";
export const FINISHED = "finished";
export const ERRORED = "errored";

export default {
  propTypes: {
    jobs: ImmutablePropTypes.map,
    requests: PropTypes.object.isRequired,
  },

  jobState(subject) {
    let state = null;
    const jobStatusTopicId = subject.jobStatusTopic

    if (jobStatusTopicId) {
      state = this.props.jobs.get('status').get(jobStatusTopicId, PROCESSING);
    }

    return state;
  },
}



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/mixins/JobMixin.js